import { Case, CaseAttributes, CaseRelationships, CaseStatus } from 'dashboard/models/case';
import { ApiModel } from 'lib/interfaces/api';

const createdAt = '2023-01-01T00:00:00.000Z';
const updatedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewCase(
  attributes?: Partial<CaseAttributes>,
  relationships?: Partial<CaseRelationships>,
  id?: string,
): Case {
  return {
    id: id || 'case_123',
    type: ApiModel.Case,
    attributes: {
      status: CaseStatus.Open,
      state: {
        name: 'open',
        token: 'state_1',
        color: 'red',
        'comment-required': true,
        'next-state-ids': [],
        'end-state': true,
        'to-transition-rules': [],
        'archived-at': null,
      },
      name: 'KYC-1',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      resolution: null,
      'checklist-items': [],
      data: {
        metadata: {},
      },
      fields: {},
      'case-attachments': [],
      'created-at': createdAt,
      'updated-at': updatedAt,
      ...attributes,
    },
    relationships: {
      'case-template': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      'case-queue': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      'case-messages': {
        data: [],
      },
      objects: {
        data: [],
      },
      creator: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      assignee: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      resolver: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      updater: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      redactor: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      tags: {
        data: [],
      },
      accounts: {
        data: [],
      },
      'case-comments': {
        data: [],
      },
      ...relationships,
    },
  };
}
